import React, { useContext, useState, useEffect } from "react"
import { useFormik, Form, FormikProvider } from "formik"
import * as Yup from "yup"
import { string, ref } from "yup"
// Dialog
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import {
     Grid,
     Stack,
     Button,
     TextField,
     Typography,
     IconButton,
} from "@mui/material"
import { useMutation } from "@apollo/client"
// Icons
import { BiMinusCircle } from "react-icons/bi"
// Src
import "../../Style/dialogstyle.scss"
import EmptyImage from "../../Assets/empty-image.png"
import { AuthContext } from "../../Context/AuthContext"
import { CREATE_WAREHOUSE, UPDATE_WAREHOUSE } from "../../Schema/Warehouse"

export default function WarehouseForm({ open, handleClose, setRefetch, dialogTitle, editData }) {
     // Change Language
     const { setAlert } = useContext(AuthContext)
     const [loading, setLoading] = useState(false)

     //====================== Creatae Warehouse =============================
     const [createWarehouse] = useMutation(CREATE_WAREHOUSE, {
          onCompleted: ({ createWarehouse }) => {
               setLoading(false)
               if (createWarehouse?.status) {
                    setAlert(true, "success", createWarehouse?.message)
                    handleClose()
                    resetForm()
                    setRefetch()
               } else {
                    setAlert(true, "error", createWarehouse?.message)
               }
          },
          onError: (error) => {
               setLoading(false)
               setAlert(true, "error", error?.message)
          },
     })
     //====================== Update Warehouse =============================
     const [updateWarehouse] = useMutation(UPDATE_WAREHOUSE, {
          onCompleted: ({ updateWarehouse }) => {
               setLoading(false)
               if (updateWarehouse?.status) {
                    setAlert(true, "success", updateWarehouse?.message)
                    handleClose()
                    setRefetch()
               } else {
                    setAlert(true, "error", updateWarehouse?.message)
               }
          },
          onError: (error) => {
               setLoading(false)
               setAlert(true, "error", error?.message)
          },
     })

     //fromik
     const CheckValidation = Yup.object().shape({
          warehouseName: Yup.string().required("require!"),
          location: Yup.string().required("require!"),
          imageSrc: Yup.string(),
          remark: Yup.string(),
     })

     const formik = useFormik({
          initialValues: {
               warehouseName: "",
               location: "",
               imageSrc: "",
               remark: "",
          },

          validationSchema: CheckValidation,
          onSubmit: async (values) => {
               console.log("...values,", values, editData?._id)
               setLoading(true)
               if (dialogTitle === "Create") {
                    createWarehouse({
                         variables: {
                              input: {
                                   ...values,
                              },
                         },
                    })
               } else {

                    updateWarehouse({
                         variables: {
                              id: editData?._id,
                              input: {
                                   ...values,
                              },
                         },
                    })

               }
          },
     })

     const {
          errors,
          touched,
          handleSubmit,
          getFieldProps,
          setFieldValue,
          values,
          resetForm,
     } = formik


     useEffect(() => {
          if (editData) {
               setFieldValue("warehouseName", editData?.warehouseName)
               setFieldValue("location", editData?.location)
               setFieldValue("remark", editData?.remark)
          }
     }, [editData])
     return (
          <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
               <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
                    <Stack direction="row" justifyContent="space-between">
                         <Stack direction="column" justifyContent="center">
                              <Typography className="dialog-title">
                                   {dialogTitle === "Create" ? "បង្កើតឃ្លាំងទំនិញ" : "កែប្រែឃ្លាំងទំនិញ"}
                              </Typography>
                         </Stack>
                         <Stack direction="column" justifyContent="center">
                              <IconButton onClick={handleClose}>
                                   <BiMinusCircle className="close-icon" />
                              </IconButton>
                         </Stack>
                    </Stack>
               </DialogTitle>

               <DialogContent dividers>
                    <FormikProvider value={formik}>
                         <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                              <Grid container rowSpacing={2} columnSpacing={3}>
                                   <Grid item xs={6} sm={12}>
                                        <Typography className="field-title">ឈ្មោះឃ្លាំងទំនិញ</Typography>
                                        <TextField
                                             className="text-field"
                                             fullWidth
                                             size="small"
                                             placeholder="ឈ្មោះឃ្លាំងទំនិញ"
                                             {...getFieldProps("warehouseName")}
                                             error={Boolean(touched.warehouseName && errors.warehouseName)}
                                             helperText={touched.warehouseName && errors.warehouseName}
                                        />
                                   </Grid>
                                   <Grid item xs={6} sm={12}>
                                        <Typography className="field-title">ទីតាំង</Typography>
                                        <TextField
                                             className="text-field"
                                             fullWidth
                                             size="small"
                                             placeholder="ទីតាំង"
                                             {...getFieldProps("location")}
                                             error={Boolean(touched.location && errors.location)}
                                             helperText={touched.location && errors.location}
                                        />
                                   </Grid>

                                   <Grid item xs={12}>
                                        <Typography className="field-title">Remark</Typography>
                                        <TextField
                                             className="text-field"
                                             fullWidth
                                             multiline
                                             rows={3}
                                             size="small"
                                             placeholder="remark"
                                             {...getFieldProps("remark")}
                                             error={Boolean(touched.remark && errors.remark)}
                                             helperText={touched.remark && errors.remark}
                                        />
                                   </Grid>
                                   <Grid item xs={12}>
                                        {loading ? (
                                             <Button className="btn-create" fullWidth>
                                                  កំពុងដំណើរការ...
                                             </Button>
                                        ) : (
                                             <Button
                                                  className="btn-create"
                                                  fullWidth
                                                  onClick={handleSubmit}
                                             >
                                                  បង្កើត
                                             </Button>
                                        )}
                                   </Grid>
                              </Grid>
                         </Form>
                    </FormikProvider>
               </DialogContent>
          </Dialog>
     )
}
